import React from 'react';
import PropTypes from 'prop-types';
import { IconRowWrapper, NumberSpan, Icon } from './styles';
/* eslint-disable */
const MatchRowIcon = ({
  matchStats, color, bg, size, weight, className,
  isSubstitution, marginRight, marginLeft, font,
}) => (matchStats &&
  <IconRowWrapper
    size={size}
    marginRight={marginRight}
    marginLeft={marginLeft}
  >
    <Icon
      className={className}
      bg={bg}
      isSubstitution={isSubstitution}
    >
      {isSubstitution &&
        <div>
          <span className="path1" />
          <span className="path2" />
        </div>
      }
    </Icon>
    <NumberSpan
      color={color}
      size={size}
      weight={weight}
      isSubstitution={isSubstitution}
      font={font}
    >
      {matchStats}
    </NumberSpan>

  </IconRowWrapper>
  );

MatchRowIcon.propTypes = {
  matchStats: PropTypes.any,
  color: PropTypes.string,
  bg: PropTypes.string,
  size: PropTypes.number,
  weight: PropTypes.string,
  className: PropTypes.string,
  isSubstitution: PropTypes.bool,
  marginRight: PropTypes.number,
  marginLeft: PropTypes.number,
};

export default MatchRowIcon;



// WEBPACK FOOTER //
// ./src/components/MatchRowIcon/index.js